import type { BrandConfig } from '../branding.types';
import { catalyzedBrand, catalyzedDevBrand } from './catalyzed';
import { exampleClientBrand, purpleBrand } from './example-client';

/**
 * Registry of all available brands
 */
export const brands: Record<string, BrandConfig> = {
  'catalyzed': catalyzedBrand,
  'catalyzed-dev': catalyzedDevBrand,
  'example-client': exampleClientBrand,
  'purple-brand': purpleBrand,
};

/**
 * Default brand ID to use when no match is found
 */
export const DEFAULT_BRAND_ID = 'catalyzed';

/**
 * Get a brand configuration by ID
 */
export const getBrandById = (brandId: string): BrandConfig => {
  return brands[brandId] || brands[DEFAULT_BRAND_ID];
};